export const GET_WORKOUTS_SUCCEED = 'Workouts/GET_WORKOUTS_SUCCEEDED';
export const GET_WORKOUTS_ERROR = 'Workouts/GET_WORKOUTS_ERROR';
export const CREATE_WORKOUT_SUCCEED = 'Workout/CREATE_WORKOUT_SUCCEEDED';
export const CREATE_WORKOUT_ERROR = 'Workout/CREATE_WORKOUT_ERROR';
export const WORKOUT_UNIQUENESS_CHECK_ERROR =
  'Workout/WORKOUT_UNIQUENESS_CHECK_ERROR';
export const RESET_WORKOUT_UNIQUENESS_ERROR =
  'Workout/RESET_WORKOUT_UNIQUENESS_ERROR';
export const GET_WORKOUT_SUCCEED = 'Workout/GET_WORKOUT_SUCCEED';
export const GET_WORKOUT_ERROR = 'Workout/GET_WORKOUT_ERROR';
export const DELETE_WORKOUT_SUCCEED = 'Workout/DELETE_WORKOUT_SUCCEED';
export const DELETE_WORKOUT_ERROR = 'Workout/DELETE_WORKOUT_ERROR';
export const UNASSIGN_CLIENT_SUCCEED = 'Workout/UNASSIGN_CLIENT_SUCCEED';
export const UNASSIGN_CLIENT_ERROR = 'Workout/UNASSIGN_CLIENT_ERROR';
export const ASSIGN_CLIENTS_SUCCEED = 'Workout/ASSIGN_CLIENTS_SUCCEED';
export const ASSIGN_CLIENTS_ERROR = 'Workout/ASSIGN_CLIENTS_ERROR';
export const RENAME_WORKOUT_SUCCEED = 'Workout/RENAME_WORKOUT_SUCCEED';
export const RENAME_WORKOUT_ERROR = 'Workout/RENAME_WORKOUT_ERROR';
export const SERIES_EXERCIES_ON_CHANGE = 'Workout/SERIES_EXERCIES_ON_CHANGE';
export const SERIES_REPS_ON_CHANGE = 'Workout/SERIES_REPS_ON_CHANGE';
export const GET_TRAINER_EXERCIES_SUCCEED = 'Workout/GET_TRAINER_EXERCIES_SUCCEED';
export const GET_TRAINER_EXERCIES_ERROR = 'Workout/GET_TRAINER_EXERCIES_ERROR';
export const GET_REPS_SUCCEED = 'Workout/GET_REPS_SUCCEED';
export const GET_REPS_ERROR = 'Workout/GET_REPS_ERROR';
export const CREATE_SERIES_SUCCEED = 'Workout/CREATE_SERIES_SUCCEED';
export const CREATE_SERIES_ERROR = 'Workout/CREATE_SERIES_ERROR';
export const CREATE_SERIES_UNIQUENESS_ERROR = 'Workout/CREATE_SERIES_UNIQUENESS_ERROR';
export const GET_SERIES_BY_ID_SUCCEED = 'Workout/GET_SERIES_BY_ID_SUCCEED';
export const GET_SERIES_BY_ID_ERROR = 'Workout/GET_SERIES_BY_ID_ERROR';
export const DELETE_SERIES_ERROR = 'Workout/DELETE_SERIES_ERROR';
export const EDIT_SERIES_SUCCEED = 'Workout/EDIT_SERIES_SUCCEED';
export const EDIT_SERIES_ERROR = 'Workout/EDIT_SERIES_ERROR';
export const EXERCISE_UNIQUENESS_CHECK_ERROR = 'Workout/EXERCISE_UNIQUENESS_CHECK_ERROR';
export const CREATE_EXERCISE_SUCCEED = 'Workout/CREATE_EXERCISE_SUCCEED';
export const CREATE_EXERCISE_ERROR = 'Workout/CREATE_EXERCISE_ERROR';
export const RESET_EXERCISE_MODEL = 'Workout/RESET_EXERCISE_MODEL';
export const GET_CLIENT_WORKOUT_SUCCEEDED = 'Workout/GET_CLIENT_WORKOUT_SUCCEEDED';
export const GET_CLIENT_WORKOUT_ERROR = 'Workout/GET_CLIENT_WORKOUT_ERROR';
export const ASSIGN_CLIENT_TO_WORKOUTS_SUCCEEDED = 'Workout/ASSIGN_CLIENT_TO_WORKOUTS_SUCCEEDED';
export const ASSIGN_CLIENT_TO_WORKOUTS_ERROR = 'Workout/ASSIGN_CLIENT_TO_WORKOUTS_ERROR';
export const LOADING_STATE = 'Workout/LOADING_STATE';
export const SUBMITTIG_LOADING_STATE = 'Workout/SUBMITTIG_LOADING_STATE';
export const UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED = 'Client/UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED';
export const UPDATE_CLIENT_WORKOUTS_ORDER_ERROR = 'Client/UPDATE_CLIENT_WORKOUTS_ORDER_ERROR';
export const SERIES_LOADING_STATE = 'Workout/SERIES_LOADING_STATE';
export const UPDATE_SERIES_ORDER_SUCCEED = 'Workout/UPDATE_SERIES_ORDER_SUCCEED';
export const UPDATE_SERIES_ORDER_ERROR = 'Workout/UPDATE_SERIES_ORDER_ERROR';


